/*------------------------------------*\
    MODULES
\*------------------------------------*/
import Flickity from 'flickity';

/*------------------------------------*\
    FLICKITY
\*------------------------------------*/
class Carousel {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;
        
        self.flkty = new Flickity(self.elem, {
            prevNextButtons: false,
            wrapAround: true,
            autoPlay: 5000,
            pageDots: true
        });
    }
}

export default Carousel;